/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TagsWithAssetCount { 
    _id: string;
    name: string;
    /**
     * count of asset where tag referenced
     */
    assetsCount: number;
}

